import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { ELEMENTS } from "@tSurya/theme/design";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: ${ELEMENTS.logo.maxWidth};
        max-height: auto;
        display: flex;
        align-items: center;
        span {
            display: flex !important;
        }
        ${isThemeActive(THEME_IDS.MGBW) ? `
            max-height: 46px;
            @media (max-width: 767px) {
                max-width: 120px;
            }
        ` : ''}
    `,
};
